import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { layout } from '../config/styles';
import { SIDEBAR_Z_INDEX } from '../styles/zIndexes';
import { theme } from '../styles/theme';

interface IProps {
  children: ReactNode;
  id?: string;
}

const Container = styled.div`
  flex: 0 0 auto;
  width: ${layout.sidebarWidth}px;
`;

const FixedContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${SIDEBAR_Z_INDEX};
  width: ${layout.sidebarWidth}px;
  height: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  padding-top: ${layout.headerHeight}px;
  background-color: ${theme.colors.level1};
  border-right: 1px solid ${theme.colors.border};
`;

const SidebarWrapper = ({ children, id }: IProps) => {
  // Wrap in fixed-width div to let browser properly calculate layout
  return (
    <Container>
      <FixedContainer id={id}>
        <Wrapper>{children}</Wrapper>
      </FixedContainer>
    </Container>
  );
};

export default SidebarWrapper;
